import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import type { DemoVideo } from '@/constants/demoVideos';

interface DemoVideoModalProps {
  video: DemoVideo | null;
  open: boolean;
  onClose: () => void;
}

export function DemoVideoModal({ video, open, onClose }: DemoVideoModalProps) {
  if (!video) return null;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-4xl p-0 overflow-hidden">
        <DialogHeader className="p-4 pb-0">
          <DialogTitle className="text-lg font-semibold">{video.title}</DialogTitle>
        </DialogHeader>

        <div className="relative aspect-video bg-black">
          <video
            src={video.videoUrl}
            controls
            autoPlay
            className="w-full h-full"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="p-4 pt-2">
          <p className="text-sm text-muted-foreground">{video.description}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
